import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Navbar from '../components/common/Navbar';
import Footer from '../components/common/Footer';
import './ReviewsPage.css';

const SERVICE_TYPES = ['All', 'Past Predictions', 'Future Consultation', 'Remedies', 'General'];

const ReviewsPage = () => {
  const [reviews, setReviews] = useState([]);
  const [filter, setFilter] = useState('All');
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  const handleBack = () => {
    // Go back if there's history, otherwise go home
    if (window.history.length > 1) navigate(-1);
    else navigate('/');
  };

  useEffect(() => {
    fetch('/api/reviews')
      .then(r => r.json())
      .then(d => { if (d.success) setReviews(d.reviews); })
      .catch(() => {})
      .finally(() => setLoading(false));
  }, []);

  const filtered = filter === 'All' ? reviews : reviews.filter(r => r.service === filter);

  return (
    <>
      <Navbar />
      <main className="reviews-page">
        <div className="reviews-page__header">
          <button
            className="reviews-page__back"
            onClick={handleBack}
            aria-label="Go back"
          >
            ←
          </button>
          <h1 className="reviews-page__title">Client Reviews</h1>
          <p className="reviews-page__sub">Real experiences from real clients</p>

          {reviews.length > 0 && (
            <div className="reviews-page__summary">
              <span className="rp-avg">{(reviews.reduce((s, r) => s + r.rating, 0) / reviews.length).toFixed(1)}</span>
              <span className="rp-stars">{'★'.repeat(5)}</span>
              <span className="rp-count">{reviews.length} reviews</span>
            </div>
          )}

          <div className="reviews-page__filters">
            {SERVICE_TYPES.map(s => (
              <button key={s} className={`rp-filter${filter === s ? ' rp-filter--active' : ''}`} onClick={() => setFilter(s)}>{s}</button>
            ))}
          </div>
        </div>

        {loading ? (
          <div className="reviews-page__loading">Loading reviews…</div>
        ) : !filtered.length ? (
          <div className="reviews-page__empty">No reviews yet for this category.</div>
        ) : (
          <div className="reviews-page__grid">
            {filtered.map(r => <ReviewCard key={r.id} review={r} />)}
          </div>
        )}

        <div className="reviews-page__cta">
          <p>Mee reading cheyali? Tilak Garu tho directly matladu.</p>
          <a href="/chat" className="rp-cta-btn">💬 Get Your Reading</a>
          {/* href is intentional — /chat is a backend-served page, not a React route */}
        </div>
      </main>
      <Footer />
    </>
  );
};

const ReviewCard = ({ review: r }) => {
  const share = () => {
    const text = r.type === 'text'
      ? `⭐ ${r.rating}/5 — "${(r.content || '').slice(0, 120)}…"\n— ${r.clientName} (${r.service})\nvtdastrology.com/reviews`
      : `⭐ ${r.rating}/5 — ${r.clientName} left a ${r.type} review!\nvtdastrology.com/reviews`;
    if (navigator.share) navigator.share({ title: 'VTD Astrology Review', text }).catch(() => {});
    else if (navigator.clipboard) navigator.clipboard.writeText(text).then(() => alert('Copied!')).catch(() => {});
  };

  return (
    <article className="rp-card">
      <div className="rp-card-top">
        <div className="rp-avatar">{(r.clientName || '?').charAt(0)}</div>
        <div className="rp-meta">
          <p className="rp-name">{r.clientName}</p>
          <p className="rp-service">{r.service}</p>
          <p className="rp-date">{new Date(r.timestamp).toLocaleDateString('en-IN', { day: 'numeric', month: 'short', year: 'numeric' })}</p>
        </div>
        <span className="rp-stars-sm">{'★'.repeat(r.rating)}{'☆'.repeat(5 - r.rating)}</span>
      </div>

      {r.type === 'text' && r.content && (
        <p className="rp-content">"{r.content}"</p>
      )}
      {r.type === 'audio' && r.fileUrl && (
        <audio controls src={r.fileUrl} className="rp-audio" />
      )}
      {r.type === 'video' && r.videoUrl && (
        <a href={r.videoUrl} target="_blank" rel="noopener noreferrer" className="rp-video-link">▶ Watch Video Review</a>
      )}

      <button className="rp-share" onClick={share}>📤 Share</button>
    </article>
  );
};

export default ReviewsPage;
